module.exports = __webpack_public_path__ + "static/img/success10.e048c85d.png";